__turbopack_context__.v({
  "activeRange": "Commentary-module-scss-module__eKUOnq__activeRange",
  "beadOfLight": "Commentary-module-scss-module__eKUOnq__beadOfLight",
  "btn": "Commentary-module-scss-module__eKUOnq__btn",
  "chapterControls": "Commentary-module-scss-module__eKUOnq__chapterControls",
  "chapterTitle": "Commentary-module-scss-module__eKUOnq__chapterTitle",
  "commentaryBreak": "Commentary-module-scss-module__eKUOnq__commentaryBreak",
  "controls": "Commentary-module-scss-module__eKUOnq__controls",
  "dividerLine": "Commentary-module-scss-module__eKUOnq__dividerLine",
  "jump": "Commentary-module-scss-module__eKUOnq__jump",
  "paragraph": "Commentary-module-scss-module__eKUOnq__paragraph",
  "playPause": "Commentary-module-scss-module__eKUOnq__playPause",
  "prevNextBtn": "Commentary-module-scss-module__eKUOnq__prevNextBtn",
  "sectionHighlightWrap": "Commentary-module-scss-module__eKUOnq__sectionHighlightWrap",
  "title": "Commentary-module-scss-module__eKUOnq__title",
  "tocBackground": "Commentary-module-scss-module__eKUOnq__tocBackground",
  "walkthroughParas": "Commentary-module-scss-module__eKUOnq__walkthroughParas",
  "walkthroughText": "Commentary-module-scss-module__eKUOnq__walkthroughText",
  "walkthroughViewport": "Commentary-module-scss-module__eKUOnq__walkthroughViewport",
});
